<template>
  <div class="first-open" :class="{ 'is-app': isApp }">
    <div class="main">
<!--      <div class="right-mask"></div>-->
      <div class="step-box">
        <div class="item">
          <img src="@/assets/images/icon-open-home-step-1.png" class="icon" />
          <p class="text">{{ $t('openAccount.t000181') }}</p>
        </div>
        <img
          src="@/assets/images/icon-open-home-step-arrow.png"
          class="icon-arrow"
        />
        <div class="item">
          <img src="@/assets/images/icon-open-home-step-2.png" class="icon" />
          <p class="text">{{ $t('openAccount.t000182') }}</p>
        </div>
        <img
          src="@/assets/images/icon-open-home-step-arrow.png"
          class="icon-arrow icon-arrow3"
        />
        <div class="item">
          <img src="@/assets/images/icon-open-home-step-3.png" class="icon" />
          <p class="text">{{ $t('openAccount.t000183') }}</p>
        </div>
        <img
          src="@/assets/images/icon-open-home-step-arrow.png"
          class="icon-arrow"
        />
        <div class="item">
          <img src="@/assets/images/icon-open-home-step-4.png" class="icon" />
          <p class="text">{{ $t('openAccount.t000184') }}</p>
        </div>
      </div>
      <div v-if="0" class="open-type">
        <div class="item">
          <div class="head">
            <img src="@/assets/images/open-account-select-hk.png" class="icon" />
            <div class="title-box">
              <span class="title">{{ $t('openAccount.t000005') }}</span>
              <span class="sub">{{ $t('openAccount.t000006') }}</span>
            </div>
          </div>
          <div class="cont">
            <div class="info-box">
              <div class="info-item">
                <img src="@/assets/images/icon-id-card.png" class="icon" />
                <p class="text">{{ $t('openAccount.t000007') }}</p>
              </div>
              <div class="info-item">
                <img src="@/assets/images/icon-address.png" class="icon" />
                <p class="text">{{ $t('openAccount.t000008') }}</p>
              </div>
              <div class="info-item">
                <img src="@/assets/images/icon-bank-card.png" class="icon" />
                <p class="text">{{ $t('openAccount.t000009') }}</p>
              </div>
            </div>
            <a class="btn-open" @click="toOpen(2)">{{ $t('openAccount.t000010') }}</a>
          </div>
        </div>
        <div class="item">
          <div class="head">
            <img src="@/assets/images/open-account-select-other.png" class="icon" />
            <div class="title-box">
              <span class="title">{{ $t('openAccount.t000132') }}</span>
              <span class="sub">{{ $t('openAccount.t000006') }}</span>
            </div>
          </div>
          <div class="cont">
            <div class="info-box">
              <div class="info-item">
                <img src="@/assets/images/icon-id-card.png" class="icon" />
                <p class="text">{{ $t('openAccount.t000011') }}</p>
              </div>
              <div class="info-item">
                <img src="@/assets/images/icon-address.png" class="icon" />
                <p class="text">{{ $t('openAccount.t000008') }}</p>
              </div>
              <div class="info-item">
                <img src="@/assets/images/icon-bank-card.png" class="icon" />
                <p class="text">{{ $t('openAccount.t000009') }}</p>
              </div>
            </div>
            <a class="btn-open" @click="toOpen(3)">{{ $t('openAccount.t000010') }}</a>
          </div>
        </div>
      </div>
      <div class="open-type-box">
        <div class="item">
          <img src="@/assets/images/open-account/hk-openAccount-bg.png" alt="" class="bg-img">
          <div class="top">
            <img src="@/assets/images/open-account/area-icon.png" alt="" class="icon">
            <span class="text">{{ $t('openAccount.personalAccount') }}</span>
            <div class="btn" @click="showHkIdDialog = true">{{ $t('openAccount.t000010') }}</div>
          </div>
          <div class="bot">
            <div class="info">
              <img src="@/assets/images/icon-id-card.png" alt="" class="icon">
              <p class="text">{{ $t('openAccount.idCard') }}</p>
            </div>
            <div class="info">
              <img src="@/assets/images/icon-address.png" alt="" class="icon">
              <p class="text">{{ $t('openAccount.t000008') }}</p>
            </div>
            <div class="info">
              <img src="@/assets/images/icon-bank-card.png" alt="" class="icon">
              <p class="text">{{ $t('openAccount.bankAccount') }}</p>
            </div>
          </div>
        </div>
        <div class="org-item" v-if="false">
          <img src="@/assets/images/open-account/org-icon.png" alt="" class="icon">
          <span class="text">{{ $t('openAccount.t000020') }}</span>
          <div class="btn">{{ $t('openAccount.t000010') }}</div>
        </div>
    </div>
  </div>
  <div class="tip-box">
    <p class="title">{{ $t('openAccount.t000012') }}</p>
      <p class="text">{{ $t('openAccount.t000013') }}</p>
      <!-- <p class="text">{{ $t('openAccount.t000014') }}</p>
      <p class="text">
        {{ $t('openAccount.t000015') }}
      </p> -->
    </div>
<!--    <a class="btn-institution" @click="insOpen()">{{ $t('openAccount.t000020') }}</a>-->

  <van-popup v-model="showHkIdDialog" class="hk-id-popup" round>
    <div class="hk-id-main">
      <p class="tip">{{ $t('openAccount.hkIdDialog_tip') }}</p>
      <p class="message">{{ $t('openAccount.hkIdDialog_message') }}</p>
      <div class="btn-box">
        <div class="btn" @click="onDenyHkId">{{ $t('openAccount.hkIdDialog_no') }}</div>
        <div class="btn" @click="onConfirmHkId">{{ $t('openAccount.hkIdDialog_yes') }}</div>
      </div>
    </div>
  </van-popup>
  </div>
</template>

<script>
import { getBrowser } from "@/utils/browser";
import { Popup } from "vant";

export default {
  components: {
    [Popup.name]: Popup
  },
  data() {
    return {
      showHkIdDialog: false,
      isApp: getBrowser().isApp
    };
  },
  methods: {
    getBrowser,
    // type 1大陆 2香港  3其他
    toOpen(process_id = 1, hasHkId = false) {
      this.$apis
        .supplementSaveApi({
          process_id,
          step_code: 1,
          step_order: 1,
          config_data: {}
        })
        .then(res => {
          if (!hasHkId) {
            this.$router.push({ path: '/open-account/chooseIdentity' });
          } else {
            this.$router.push({ path: "/open-account/openReference", query: { hasHkId: 1 } });
          }
        });
    },

    onDenyHkId() {
      this.showHkIdDialog = false;
      this.toOpen(3);
    },

    onConfirmHkId() {
      this.showHkIdDialog = false;
      this.toOpen(2, true);
    },

    // 机构开户
    insOpen(){
      this.$router.push({
        path: '/open-account/openReference',
        query: {
          name: 'institutional'
        }
      })
    }
  }
};
</script>

<style scoped lang="less">
.first-open {
  display: flex;
  flex-direction: column;
  padding-bottom: 50px;
  min-height: calc(100vh - 100px);
  box-sizing: border-box;
  background: #F9FAFC;
  &.is-app {
    min-height: 100vh;
  }
  .main {
    margin-bottom: auto;
    padding: 0 32px;
    background: linear-gradient(
      to bottom,
      #17161c 0%,
      #17161c 40%,
      rgba(23, 22, 28, 0.6) 60%,
      rgba(23, 22, 28, 0) 90%,
      rgba(23, 22, 28, 0) 100%
    );
    position: relative;
    .right-mask {
      position: absolute;
      right: -100px;
      top: 0;
      width: 172px;
      height: 208px;
      background: radial-gradient(#e1b395, rgba(230, 206, 191, 0));
      border-radius: 50%;
      filter: blur(100px);
    }
    overflow: hidden;
    .step-box {
      position: relative;
      z-index: 9;
      margin-top: 70px;
      display: flex;
      justify-content: space-between;
      text-align: center;
      .icon-arrow {
        margin-left: -10px;
        margin-top: 30px;
        width: 50px;
        height: 7px;
      }
      .item {
        margin-left: -20px;
        color: #fff;
        font-size: 28px;
        font-weight: 500;
        display: flex;
        align-items: center;
        flex-direction: column;
        &:nth-child(1),&:last-child {
          margin-left: 0;
        }
        .icon {
          width: 72px;
          height: 72px;
        }
        .text {
          margin-top: 10px;
          line-height: 32px;
        }
      }
    }
    .open-type {
      margin-top: 50px;
      .item {
        padding-top: 30px;
        margin-bottom: 24px;
        position: relative;
        .head {
          position: absolute;
          left: 0;
          top: 0;
          height: 68px;
          background: linear-gradient(90deg, #ffffff, #e6ccbb 100%);
          border-radius: 16px 0px 16px 0px;
          box-shadow: 4px 8px 12px 0px rgba(181, 143, 119, 0.1);
          display: flex;
          align-items: center;
          min-width: 416px;
          padding-right: 20px;
          line-height: 1;
          .icon {
            margin-left: 20px;
            width: 48px;
            height: 48px;
          }
          .title-box{
            display: flex;
            align-items: flex-end;
          }
          .title {
            margin: 0 12px;
            font-size: 32px;
            font-weight: 500;
            color: #17161c;
          }
          .sub {
            color: rgba(23, 22, 28, 0.85);
            font-size: 28px;
            font-weight: 400;
          }
        }
        .cont {
          padding: 40px 28px 10px;
          //min-height: 162px;
          background: #ffffff;
          border-radius: 24px;
          display: flex;
          align-items: center;
          .info-box {
            padding: 30px 10px;
            flex: 1;
            display: flex;
            justify-content: space-between;
            .info-item {
              display: flex;
              flex-direction: column;
              align-items: center;
              .icon {
                width: 50px;
                height: 50px;
              }
              .text {
                text-align: center;
                margin-top: 10px;
                font-size: 24px;
                color: #747377;
                line-height: 28px;
              }
            }
          }
          .btn-open {
            margin-left: 20px;
            line-height: 60px;
            background: #17161c;
            border-radius: 60px;
            padding: 0 20px;
            color: #fff;
            font-size: 28px;
            font-weight: 500;
            margin-bottom: 30px;
          }
        }
      }
    }
    .open-type-box {
      margin-top: 60px;
      .item {
        position: relative;
        height: 332px;
        .bg-img {
          position: absolute;
          height: 100%;
        }
        .top {
          position: relative;
          display: flex;
          align-items: center;
          padding-top: 40px;
          margin: 0px 30px;
          .icon {
            width: 92px;
            height: 92px;
          }
          .text {
            margin-left: 18px;
            font-size: 32px;
            font-weight: 500;
            color: #17161c;
          }
          .btn {
            margin-left: auto;
            width: 140px;
            height: 60px;
            line-height: 60px;
            text-align: center;
            background: #17161c;
            border-radius: 200px;
            color: white;
          }
        }
        .bot {
          position: relative;
          display: flex;
          margin: 26px 30px 0px;
          border: 0.5px solid;
          border-image: linear-gradient(90deg, #ffebde, #ffeadd 100%) 0.5 0.5;
          border-radius: 16px;
          .info {
            flex: 1;
            height: 140px;
            background: linear-gradient(90deg,#fffcfb, #fff9f6 100%);
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            padding: 0 8px;
            .icon {
              width: 64px;
              height: 64px;
              flex-shrink: 0;
            }
            .text {
              color: #747377;
              font-size: 22px;
              text-align: center;
              line-height: 1.3;
              margin-top: 6px;
            }
          }
        }
      }
      .org-item {
        display: flex;
        align-items: center;
        margin-top: 26px;
        background: white;
        height: 160px;
        border-radius: 24px;
        padding: 0 30px;
        .icon {
          width: 92px;
          height: 92px;
        }
        .text {
          margin-left: 18px;
          font-size: 32px;
          font-weight: 500;
          color: #17161c;
        }
        .btn {
          margin-left: auto;
          width: 140px;
          height: 60px;
          line-height: 60px;
          text-align: center;
          background: #17161c;
          border-radius: 200px;
          color: white;
        }
      }
    }
  }

  .tip-box {
    margin-top: 40px;
    padding: 0 32px;
    .title {
      font-size: 32px;
      font-weight: 600;
    }
    .text {
      font-size: 28px;
      color: rgba(23, 22, 28, 0.6);
      line-height: 40px;
    }
  }
  .btn-institution{
    display: block;
    margin-top: 30px;
    text-align: center;
    font-size: 28px;
    color: #328CF4;
    font-weight: 400;
  }
}
.hk-id-popup {
  width: 600px;
  border-radius: 32px;
  .hk-id-main {
    padding: 45px;
    text-align: center;
    .tip {
      font-size: 36px;
      font-weight: 500;
      color: #17161c;
    }
    .message {
      margin-top: 32px;
      font-size: 32px;
      color: #747377;
    }
    .btn-box {
      display: flex;
      margin-top: 40px;
      .btn {
        flex: 1;
        height: 104px;
        line-height: 104px;
        border-radius: 104px;
        font-size: 28px;
        font-weight: 500;
        color: #17161c;
        background: rgba(15, 15, 47, 0.04);
        & ~ .btn {
          margin-left: 20px;
          color: #fff;
          background: #17161c;
        }
      }
    }
  }
}

.black-theme{
  .first-open{
    background: #1B1C24;
    .main{
      .right-mask {
        filter: blur(200px);
      }
      .open-type {
        .item{
          .cont{
            background: #262830;
            .info-box{
              .icon{
                filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(180deg) brightness(200%) contrast(100%);
                opacity: 1;
              }
              .text{
                color: #9D9D9F;
              }
            }
            .btn-open{
              background: #377CFB;
            }
          }
        }
      }
      .open-type-box {
        .item {
          .bg-img {
            content: url("~@/assets/images/open-account/hk-openAccount-bg-dark.png");
          }
          .top {
            .text {
              color: white;
            }
            .btn {
              background: #377cfb;
            }
          }
          .bot {
            border-image: linear-gradient(90deg, #4d4039, #3d3532 100%) 0.5 0.5;
            .info {
              background: linear-gradient(90deg,#2f2f34, #2e2b2c 100%);
              &:nth-child(1) {
                .icon {
                  content: url("~@/assets/images/icon-id-card-dark.png");
                }
              }
              &:nth-child(2) {
                .icon {
                  content: url("~@/assets/images/icon-address-dark.png");
                }
              }
              &:nth-child(3) {
                .icon {
                  content: url("~@/assets/images/icon-bank-card-dark.png");
                }
              }
              .text {
                color: #9D9D9F;
              }
            }
          }
        }
        .org-item {
          background: #262830;
          .text {
            color: white;
          }
          .btn {
            background: #377cfb;
          }
        }
      }
    }
    .tip-box{
      .title{
        color: #fff;
      }
      .text{
        color: #9D9D9F;
      }
    }
  }
  .hk-id-popup {
    background: #262830;
    .hk-id-main {
      .tip {
        color: #fff;
      }
      .message {
        color: #9D9D9F;
      }
      .btn-box {
        .btn {
          color: #fff;
          background: rgba(255, 255, 255, 0.1);
          & ~ .btn {
            background: #377CFB;
          }
        }
      }
    }
  }
}
</style>
